import {
  rankingRegionalResponseSchema,
  type RankingRegionalResponse,
} from '@/features/benchmarking/schemas/benchmarkingRankingRegional';
import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';

export type GetBenchmarkingRankingRegionalParams = { escolaId: number };

export const getBenchmarkingRankingRegional = httpGetAdapter<
  RankingRegionalResponse,
  GetBenchmarkingRankingRegionalParams
>({
  url: (params) => `/v3/microdados/escola/${params.escolaId}/ranking-regional`,
  schema: rankingRegionalResponseSchema,
});
